import Link from 'next/link'
import mix from '@utils/styles/mix'

import styles from './SiteHeader.module.css'

export function MenuLinks ({ links }) {
    return links.map(link => (
        <li key={link.to}>
            <Link className={styles.menuLink} href={link.to} prefetch={false}>
                {link.t}
            </Link>
        </li>
    ))
}

export function MenuGroup ({ id, label, className, children, ...rest }) {
    return (
        <div className={mix([styles.menuGroup, className])} {...rest}>
            <p className={styles.menuLabel} id={id}>{label}</p>
            <ul aria-labelledby={id}>{children}</ul>
        </div>
    )
}
